import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { LocaleStorageService } from "../locale-storage.service";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  
constructor(private localStorageService: LocaleStorageService){}

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    // Apply the headers
    req = req.clone({
      headers: req.headers.set(
        'flc-auth', this.localStorageService.getData('sessionId') ? this.localStorageService.getData('sessionId') : "admin"
      ),
    });

    // Also handle errors globally
    return next.handle(req).pipe(
      tap(x => x, err => {
        // do nothing
      })
    );
  }
}
